<template>
    <HeaderPanel />
    <ContextMenu ref="menu" :model="menuItems" />
    <Tabs class="tabs" value="2">
        <TabList>
            <Tab value="0">СМС</Tab>
            <Tab value="1">WhatsApp</Tab>
            <Tab value="2">История SMSc</Tab>
        </TabList>
        <TabPanels>
            <TabPanel value="0">
                <SMScPrice />
            </TabPanel>
            <TabPanel value="1">
                <WazzupMail />
            </TabPanel>
            <TabPanel value="2">
                <SMScHistory />
            </TabPanel>
        </TabPanels>
    </Tabs>
</template>

<script>
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import HeaderPanel from '@/components/HeaderPanel.vue';
import SMScPrice from '@/components/SmsPage/SMScPrice.vue';
import WazzupMail from '@/components/SmsPage/WazzupMail.vue';
import SMScHistory from '@/components/SmsPage/SMScHistory.vue';

export default {
    components: {
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        HeaderPanel,
        SMScPrice,
        WazzupMail,
        SMScHistory        
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.tabs {
    border: 1px solid #a3a3a3;
    border-radius: 10px;
    padding: 10px;
    min-height: 98vh;
}
</style>